var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor filter" },
    [
      _vm._l(_vm.clone.groups, function (group, index) {
        return _c(
          "div",
          { key: group.id },
          [
            _c("FilterGroup", {
              attrs: {
                "on-removed": _vm.onFilterGroupRemoved,
                "show-remove-button": _vm.clone.groups.length > 1,
                automation: _vm.automation,
              },
              model: {
                value: _vm.clone.groups[index],
                callback: function ($$v) {
                  _vm.$set(_vm.clone.groups, index, $$v)
                },
                expression: "clone.groups[index]",
              },
            }),
            _vm._v(" "),
            _vm.clone.groups.length > 1 && index !== _vm.clone.groups.length - 1
              ? _c("div", { staticClass: "filter-condition-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "filter-condition" },
                    [
                      _c(
                        "a-select",
                        {
                          class: { hovered: _vm.selectHovered },
                          attrs: { value: _vm.clone.operator },
                          on: {
                            change: function (op) {
                              return (_vm.clone.operator = op)
                            },
                            click: function (e) {
                              e.stopPropagation()
                            },
                            mouseenter: function () {
                              return (_vm.selectHovered = true)
                            },
                            mouseleave: function () {
                              return (_vm.selectHovered = false)
                            },
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "or" } }, [
                            _vm._v(_vm._s(_vm.$t("chatbotv2.or"))),
                          ]),
                          _vm._v(" "),
                          _c("a-select-option", { attrs: { value: "and" } }, [
                            _vm._v(" " + _vm._s(_vm.$t("chatbotv2.and"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "filter-add-group-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "filter-add-group",
            on: { click: _vm.addFilterGroup },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.addFilterGroup")))]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-add-group-plus" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }